// @ts-ignore
import Logo from "./chronos_img.png";
import "./Title.css";

const Title: React.FC = () => {
  return (
    <div className="logo-title-container">
      <img src={Logo} alt="Janus Logo" className="logo-image" />
      <p className="logo-subtext">
Image Repository Summary View      </p>
    </div>
  );
};

export default Title;
